import * as React from 'react'
import { FC, memo } from 'react'
import { useFormContext } from 'react-hook-form'
import Title from '@organisms/Title'
import DeleteButton from '@templates/DeleteButton'
import LineFields from '@templates/AddNewItemModal/Content/LineFields'
import FieldComponent from '@templates/Field'
import { ExternalLineWrapper } from '@templates/AddNewItemModal/Content/LineFields/styled'
import { memoEqual } from '@utils/memo'
import { log } from '@utils/console'
import useCommonRiskMapFields from '@modals/RiskMapModal/Dangers/useCommonRiskMapFields'
import { Container, SecondLine, TitleWrapper, Wrapper } from './styled'

type Props = {
  id: string
  index: number
  remove: (index: number) => void
  isLast: boolean
}

const DangersFieldsBlock: FC<Props> = ({ id, index, remove, isLast }) => {
  const methods = useFormContext()

  const {
    dangerWorkPlacesField,
    dangersObjects,
    dangerKindsField,
    dangerHazardsField,
    dangerEventsField,
  } = useCommonRiskMapFields(methods, {
    index,
    initFilters: {
      custom: false,
    },
  })

  const handleDelete = () => {
    log('handleDelete', index)
    remove(index)
  }

  return (
    <Container isLast={isLast} id={`risk-map-danger-fields-${index}`}>
      <Wrapper key={id}>
        <TitleWrapper>
          <Title>Опасность</Title>
          <DeleteButton onClick={handleDelete} id="risk-map-danger-delete">
            Удалить опасность
          </DeleteButton>
        </TitleWrapper>
        <ExternalLineWrapper>
          <LineFields
            fields={[
              dangerWorkPlacesField({ withManualEntryText: false }),
              dangersObjects({ withManualEntryText: false }),
              dangerKindsField({ withManualEntryText: false }),
              dangerHazardsField({ withManualEntryText: false }),
            ]}
          />
        </ExternalLineWrapper>
        <SecondLine>
          <FieldComponent
            {...dangerEventsField({ withManualEntryText: false })}
          />
        </SecondLine>
      </Wrapper>
    </Container>
  )
}

export default memo(DangersFieldsBlock, memoEqual)
